import { render } from "./TransporteBadge.vue?vue&type=template&id=2181c255&scoped=true"
import script from "./TransporteBadge.vue?vue&type=script&lang=js"
export * from "./TransporteBadge.vue?vue&type=script&lang=js"

import "./TransporteBadge.vue?vue&type=style&index=0&id=2181c255&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2181c255"]])

export default __exports__